import { motion } from 'framer-motion';
import { ProjectFormat } from '../../types';

interface FullBleedVideoProps {
  src: string;
  title: string;
  caption?: string;
  format?: ProjectFormat;
}

export function FullBleedVideo({
  src,
  title,
  caption,
  format = 'desktop',
}: FullBleedVideoProps) {
  const isMobileFormat = format === 'mobile';

  return (
    <motion.figure
      initial={{ opacity: 0, y: 32 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.25 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className={`space-y-4 ${isMobileFormat ? 'flex flex-col items-center' : ''}`}
    >
      <div
        className={`relative overflow-hidden rounded-[2rem] bg-black/[0.03] p-2 md:p-3 ${
          isMobileFormat ? 'w-full max-w-[23rem]' : ''
        }`}
      >
        <video
          src={src}
          className={
            isMobileFormat
              ? 'block w-full rounded-[1.6rem] object-cover aspect-[9/19]'
              : 'block h-auto w-full rounded-[1.4rem] object-contain'
          }
          autoPlay
          loop
          muted
          playsInline
          preload="metadata"
          aria-label={title}
        />
      </div>
      {caption ? (
        <figcaption
          className={`label ${
            isMobileFormat ? 'text-center' : ''
          }`}
        >
          {caption}
        </figcaption>
      ) : null}
    </motion.figure>
  );
}
